import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import ImageSvg from "../ui/image-svg";

export const FacilidadeSegurancaSection = () => {
  return (
    <section className="py-10 md:py-24 ">
      <div className="container">
        <div className="grid md:grid-cols-2 gap-8 items-center md:mb-24 mb-10">
          <h2 className="mb-5 text-n-text-green text-3xl font-semibold md:mb-6 md:text-4xl lg:text-5xl">
            Facilidade e segurança no transporte de veículos
          </h2>
          <div className="order-1 md:order-2">
            <p className="md:text-lg text-n-text-neutral mb-8">
              Conectamos você a uma rede de transportadores confiáveis,
              <strong>garantindo a entrega do seu veículo</strong> com total
              segurança, tecnologia e eficiência.
            </p>
            <p className="md:text-lg text-n-text-neutral mb-8">
              Descubra <strong>uma nova forma de transportar seu carro</strong>{" "}
              , sem complicações e com o suporte de quem entende
            </p>
            {/* <div className="space-y-6 mb-8">
              <div className="flex items-start gap-4">
                <div className="bg-n-text-green rounded-full p-2 mt-1">
                  <Smartphone className="h-4 w-4 text-white" />
                </div>
                <div>
                  <h3 className="font-semibold text-n-text mb-1">
                    Processo 100% Digital
                  </h3>
                  <p className="text-sm text-gray-600">
                    Faça tudo pelo app ou site, sem precisar sair de casa
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="bg-n-text-green rounded-full p-2 mt-1">
                  <Truck className="h-4 w-4 text-white" />
                </div>
                <div>
                  <h3 className="font-semibold text-n-text mb-1">
                    Transportadoras Verificadas
                  </h3>
                  <p className="text-sm text-gray-600">
                    Parceiros rigorosamente selecionados e avaliados
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="bg-n-text-green rounded-full p-2 mt-1">
                  <Shield className="h-4 w-4 text-white" />
                </div>
                <div>
                  <h3 className="font-semibold text-n-text mb-1">
                    Seguro Incluso
                  </h3>
                  <p className="text-sm text-gray-600">
                    Cobertura completa durante todo o transporte
                  </p>
                </div>
              </div>
            </div> */}

            <Link to="/fazer-cotacao">
              <Button>
                Agendar meu transporte
                <ArrowRight className=" h-6 w-6" />
              </Button>
            </Link>
          </div>
        </div>
        <div className="order-2 md:order-1">
          <ImageSvg
            src="conceito-negocio.svg"
            alt="Facilidade e segurança no transporte"
            className="max-w-full h-auto"
          />
        </div>
      </div>
    </section>
  );
};
